import renderFirstAdv from "./renderFirstAdv";
import renderSecondAdv from "./renderSecondAdv";
import renderThirdAdv from "./renderThirdAdv";
import renderMarketplaceAdv from "./marketplaceAdv/renderMarketplaceAdv";
import renderSportAdv from "./sportAdv/renderSportAdv";
import renderFunAdv from "./funAdv/renderFunAdv";

export default function (opt, path, newsIndex) {
    let newsId = typeof path !== 'undefined' ? path.match(/(_n|objectId=)(\d+)/i)[2] : opt.newsId;

    if (opt.subsiteName === 'education') {
        renderMarketplaceAdv(newsId, newsIndex);
        if(opt.subsiteName === 'sport'){
            renderSportAdv(newsIndex);
        }
    } else if (opt.subsiteName === 'fun') {
        renderFunAdv(newsId)
    } else {
        renderFirstAdv(newsId, 100, newsIndex, opt);
        renderSecondAdv(newsId, 200, newsIndex, opt);
        renderThirdAdv(newsId, 300, newsIndex, opt);
    }
}